<template>
    <el-card shadow="never" class="aui-card--fill">
     <div class="mod-demo__scopecity">
          
            <el-divider content-position="left">经纪人信息</el-divider>
            <div class="topBox">
                <p>
                    <span>姓名：{{ userInfo.brokerName }}</span>
                    <span>一级上级姓名：{{ userInfo.superiorBrokerName }}</span>
                    <span>二级上级姓名：{{ userInfo.superiorSuperiorBrokerName }}</span>
                    <span>经济人等级：{{ userInfo.brokerLevel }}</span>
                </p>
                <p>
                    <span>手机号：{{ userInfo.brokerMobile }}</span>
                    <span>一级上级手机号：{{ userInfo.superiorBrokerMobile }}</span>
                    <span>二级上级手机号：{{ userInfo.superiorSuperiorBrokerMobile }}</span>
                    <span>团队规模：{{ userInfo.brokerTeamSize }}</span>
                </p>
            </div>
            
            <el-divider  content-position="left">经纪人业绩</el-divider>
            <tableBroker ref="performance" ></tableBroker>
            <el-divider  content-position="left">团队津贴</el-divider>
            <tableAllowance ref="aaa" :todayAwardLoan="todayAwardLoan" :totalAwardAmount="totalAwardAmount"></tableAllowance>
            <el-divider content-position="left">团队信息</el-divider>
            <tableInfo></tableInfo>
        </div> 
    </el-card>
</template>

<script>
import tableBroker from '../../../components/wx/tableBroker.vue'
import tableInfo from '../../../components/wx/tableInfo.vue'
import tableAllowance from '../../../components/wx/tableAllowance.vue'
export default {
    components:{
        tableBroker,
        tableInfo,
        tableAllowance,
    },
    data() {
        return {
            userInfo: {},
            todayAwardLoan: '', //今日分润
            totalAwardAmount: '', //总津贴
        }
    },
    mounted(){
        this.getInfo()
    },
    methods: {
        getaaa(){
            console.log(this.$refs.aaa)
        },
        getInfo () {
            this.$http.get(`/sys/sluser/brokerDetails/${this.$route.params.scopeCityId}`).then(({ data: res }) => {
                if (res.code !== 0) {
                return this.$message.error(res.msg)
                }
               this.userInfo = res.data
               this.$refs.performance.init(res.data) 
            }).catch(() => {})

            this.$http.get(`/sys/slteamcurrentstate/user/${this.$route.params.scopeCityId}`).then(({ data: res }) => {
                if (res.code !== 0) {
                return this.$message.error(res.msg)
                }
                // todayAwardLoan 
                this.todayAwardLoan = res.data ? res.data.todayAwardLoan : '0'
            }).catch(() => {})
            this.$http.get(`/sys/sluserteam/user/${this.$route.params.scopeCityId}`).then(({ data: res }) => {
                if (res.code !== 0) {
                return this.$message.error(res.msg)
                }
                // totalAwardAmount
                this.totalAwardAmount = res.data ? res.data.totalAwardAmount : '0'
              
           
            }).catch(() => {})
        },
    },
}
</script>

<style scoped lang="scss">
.topBox{
    display: flex;
    flex-direction: column;
    >P{
        margin: 10px 0;
        display: flex;
        justify-content: space-between;
        >span{
            width: 30%;
        }
    }
}
h3{
    margin: 20px 0;
    border-bottom: 1px solid #ccc;
}
</style>